import { MdAttachFile, MdEditNote } from 'react-icons/md';
import styles from './ActionButtons.module.css';
import { FaUsers } from 'react-icons/fa';
import { LuGitPullRequestArrow } from 'react-icons/lu';

const ActionButtons = () => {
    const actions = [
        {icon: <MdEditNote color='#10A37F' size={24} /> ,label: 'Nueva Transacción', primary: false },
        {icon: <FaUsers color='#10A37F' size={22}/> , label: 'Nuevo Contacto', primary: false },
        { icon: <MdAttachFile color='#10A37F' size={22}/>, label: 'Subir Documento', primary: false },
        {icon: <LuGitPullRequestArrow color='#10A37F' size={22}/> , label: 'Automatiza', primary: false }
    ];

    return (
        <div className={styles.actionButtons}>
            {actions.map((action, index) => (
                <button
                    key={index}
                    className={`${styles.actionBtn} ${action.primary ? styles.primary : ''}`}
                >
                 {action.icon} {action.label}
                </button>
            ))}
        </div>
    );
};

export default ActionButtons;